function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgPlans1 = function SvgPlans1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 164 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.002,
    cy: 70.7651,
    rx: 7.61133,
    ry: 9.51416,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.1113,
    cy: 70.7651,
    rx: 7.61133,
    ry: 9.51416,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10248_64146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1113 58.1255C55.1113 50.3935 61.3793 44.1255 69.1113 44.1255H102.002C109.734 44.1255 116.002 50.3935 116.002 58.1255V83.4048C116.002 91.1368 109.734 97.4048 102.002 97.4048H69.1113C61.3793 97.4048 55.1113 91.1368 55.1113 83.4048V58.1255Z",
    fill: "#2C4BD3"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 70.335,
    cy: 70.1309,
    r: 6.34277,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.78,
    cy: 70.1309,
    r: 6.34277,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0195,
    y: 32.0742,
    width: 5.07422,
    height: 12.6855,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.5566,
    cy: 32.0742,
    r: 5.07422,
    fill: "#00039C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0876 58.7139C61.5802 61.7584 57.2248 63.5767 55.1105 63.7881C54.4767 53.0054 56.3791 44.7598 67.1628 44.1255H77.3102C77.3102 46.0283 77.471 51.1025 73.0066 51.1025C65.8932 51.1025 62.7218 54.9082 62.0876 58.7139Z",
    fill: "#5071FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.943 90.3509C97.8002 90.8559 95.9731 94.1791 95.736 97.3749C113.077 98.8628 116.002 92.2165 116.002 85.3006L116.002 75.2029C114.038 75.2029 108.8 75.0429 108.8 79.4855C108.8 86.5639 104.871 89.7198 100.943 90.3509Z",
    fill: "#2540B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3577 51.5136C61.5769 53.0449 62.9179 56.2038 62.9179 56.2038C65.2991 51.6184 70.5503 51.2508 71.8455 51.1283C71.8455 51.1283 72.0969 50.757 70.4446 49.5882C68.2918 48.0656 65.5966 49.5883 63.3577 51.5136Z",
    fill: "#E7EBFA"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10248_64146",
    x: 0.299869,
    y: 0.725487,
    width: 163.691,
    height: 156.079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.41146,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360628 0 0 0 0 0.468474 0 0 0 0 1 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10248_64146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10248_64146",
    result: "shape"
  }))));
};
export default SvgPlans1;